<template>
    <el-container class="healthy page-x" direction="vertical">
        <drag-dialog title="健康体检状态轨迹" v-model="dialogVisible">
            <div class="dialog-list">
                <!-- <div class="title">服务轨迹</div> -->
                <div class="dialog-list-box">
                    <el-table :data="historicalTrack" border style="width: 100%">
                        <el-table-column prop="changeTime" label="时间"></el-table-column>
                        <el-table-column prop="targetStatus" label="状态"></el-table-column>
                        <el-table-column prop="operation" label="操作">
                            <template slot-scope="scoped">
                                <span>{{
                                        scoped.row.operation | filterValue(operation)
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>
            </div>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { cardType, orderState, relation, operation } from "@/assets/js/options";
export default {
    name: "healthy",
    components: { dragDialog },
    data() {
        return {
            cardType, // 证件类型list
            orderState, // 订单状态list
            relation, // 与权益人关系list
            operation, // 操作list
            // table表格
            loading: false,
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
            historicalTrack: [], // 订单状态历史轨迹
        };
    },
    methods: {
        /**
         * 显示弹窗
         */
        showDetail(id) {
            // 清空状态
            this.historicalTrack = []
            this.dialogVisible = true;
            // 请求
            this.getHistoricalTrack(id)
        },
        /**
         * 跳转详情
         */
        toDetail(id,url) {
            this.$router.push({
                name: 'ServiceOrderHealthyDetail',
                query: {
                    id,url
                }
            })
        },
        /**
         * 订单状态历史轨迹
         */
        async getHistoricalTrack(id) {
            let res = await this.axios.get(this.getApiUrl("medicalOrderHistoricalTrack"), {
                params: { orderId: id },
            });
            this.historicalTrack = res?.data || [];
            console.log(this.historicalTrack)
        }
    },
    filters: {
        filterValue(text, data) {
            return (
                data.find((item) => {
                    if (text === item.value) {
                        return item;
                    }
                })?.label || text
            );
        },
    }
};
</script>

<style lang="scss" scoped>
</style>